module.exports = __webpack_public_path__ + "static/media/Figure7.34b14402.jpg";